<template>
  <div class="contactpage">
    <div class="container" v-html="contactForm.html_data"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      wpData: wpData,
      contactForm: "",
    };
  },
  mounted() {
    fetch(
      `${this.wpData.rest_url}/wp/v2/pagedata?page_title=Contact Us&page_type=shortcode`
    )
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        this.contactForm = data;
        $(document).ready(function () {
          $(".contactpage form .frm_fields_container").addClass("row");
          $(".contactpage form .frm_fields_container").prepend(
            "<div class='col-md-6 textarea-container'></div>"
          );
          $(".contactpage form .frm_fields_container").prepend(
            "<div class='col-md-6 input-container'></div>"
          );
          $(".contactpage form textarea").addClass("form-control");
          $(
            ".contactpage form .frm_fields_container .textarea-container"
          ).prepend($(".contactpage form textarea").parent());
          $(".contactpage form input").each(function () {
            if (
              $(this).attr("type") == "text" ||
              $(this).attr("type") == "email"
            ) {
              $(this).addClass("form-control");
            }
          });
          $(".contactpage form .frm_form_field").each(function () {
            if (!$(this).parent().hasClass("textarea-container")) {
              $(
                ".contactpage form .frm_fields_container .input-container"
              ).prepend($(this));
            }
          });
          $(".contactpage form .frm_submit button").html("Send Message");
          $(".contactpage form .frm_submit button").addClass("contact-btn");
        });
      });
  },
  methods: {
    gotoMenuPage: function (event) {
      alert("Event1");
    },
  },
};
</script>

<style>
.contactpage {
  position: relative;
  width: 100%;
  min-height: calc(100vh - 100px);
  padding: 50px 0;
  background: #fff;
  color: #172c62;
}
.contactpage form .frm_fields_container {
  display: flex !important;
}
.contactpage form legend {
  display: none;
}
.contactpage .frm_style_formidable-style.with_frm_style input[type="text"],
.contactpage .frm_style_formidable-style.with_frm_style input[type="email"] {
  height: 42px;
}
.contactpage .frm_style_formidable-style.with_frm_style textarea {
  height: 170px;
}
.contactpage form h3.frm_form_title,
.contactpage form .frm_description p {
  font-family: brandinglight !important;
}
.contactpage form h3.frm_form_title {
  font-size: 42px !important;
  color: #172c62 !important;
  margin: 0 !important;
  padding: 0 !important;
  text-align: center;
}
.contactpage form .frm_description p {
  font-size: 22px !important;
  color: #000;
  max-width: 650px;
  margin: auto;
  text-align: center !important;
}
.contactpage form .col-md-6 {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.contactpage form .form-field label {
  display: none !important;
}
.contactpage form .form-control {
  transition: all 0.2s ease-in-out;
  box-shadow: none;
}
.contactpage form .form-control:hover {
  box-shadow: 0 2px 10px 4px rgba(0, 0, 0, 0.08);
  border: none;
}
.contactpage form .form-control::placeholder {
  color: #226bb5;
}
.contactpage .frm_style_formidable-style.with_frm_style .frm_submit {
  margin: auto;
}
.contactpage
  .frm_style_formidable-style.with_frm_style
  .frm_submit
  .contact-btn {
  margin: 50px auto;
  font-family: brandinglight;
  background: none;
  color: #226bb5;
  border: 1px solid #226bb5;
  border-radius: 0;
  padding: 10px 20px;
  font-size: 20px;
  transition: all 0.2s ease-in-out;
}
.contactpage
  .frm_style_formidable-style.with_frm_style
  .frm_submit
  .contact-btn:hover {
  color: #fff;
  background: #226bb5;
}

@media screen and (min-width: 900px) {
  .contactpage form {
    margin-top: 70px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AppContact.vue